import { useState, FormEvent } from 'react';
import './LandingPage.css';

const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfDRIaH3UZ4UHb8Cx8yVI_f9umhHedYNKnN7t5tLhKDBaJqlw/formResponse';
const EMAIL_ENTRY_ID = 'entry.1535212030';

export function LandingPage() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' } | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setMessage({ text: 'Please enter your email address.', type: 'error' });
      return;
    }

    setIsSubmitting(true);
    setMessage(null);

    try {
      const formData = new FormData();
      formData.append(EMAIL_ENTRY_ID, trimmedEmail);

      // Google Forms doesn't support CORS, so we use no-cors mode
      // This means we can't read the response, but the submission still works
      await fetch(GOOGLE_FORM_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: formData,
      });

      // Assume success since we can't read the response
      setMessage({ text: "You're on the list! We'll be in touch when we launch.", type: 'success' });
      setEmail('');
    } catch {
      setMessage({ text: 'Something went wrong. Please try again.', type: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="landing-page">
      {/* Decorative corners */}
      <div className="corner corner-tl" />
      <div className="corner corner-tr" />
      <div className="corner corner-bl" />
      <div className="corner corner-br" />

      <main className="landing-container">
        <header className="brand">
          <h1 className="logo">
            Page<span>craft</span>
          </h1>
          <p className="studio">Studio</p>
        </header>

        <p className="tagline">Where memories are crafted into pages worth sharing.</p>

        <div className="divider">
          <span className="divider-line" />
          <span className="divider-icon">✦</span>
          <span className="divider-line" />
        </div>

        <p className="description">
          A digital scrapbooking platform that captures the creative freedom of physical scrapbooking.
          Arrange photos, add text, layer elements — then share your creations with the people who matter.
        </p>

        <form className="signup-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="email"
              className="email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              autoComplete="email"
              disabled={isSubmitting}
            />
            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Joining...' : 'Join Waitlist'}
            </button>
          </div>
          {message && (
            <div className={`form-message ${message.type}`}>
              {message.text}
            </div>
          )}
        </form>

        <div className="launch-info">
          <p className="launch-label">Expected Launch</p>
          <p className="launch-date">Q2 2026</p>
        </div>

        <footer className="landing-footer">
          <p>© 2025–2026 PageCraft Studio. All rights reserved.</p>
        </footer>
      </main>
    </div>
  );
}
